<div class="sidebar-footer" [class.sidebar-footer--collapsed]="collapsed">

  <!-- User block: hidden when collapsed, so only the logout icon remains. -->
  <ng-container *ngIf="!collapsed">
    <div class="sidebar-footer__user" *ngIf="me$ | async as me; else userSkeleton" [title]="fullname(me)">
      <img
        *ngIf="avatarSrc(me); else initialsAvatar"
        class="sidebar-footer__avatar sidebar-footer__avatar--photo"
        [src]="avatarSrc(me)"
        [alt]="fullname(me)">
      <ng-template #initialsAvatar>
        <span class="sidebar-footer__avatar" [style.backgroundColor]="avatarColor(me)">
          {{ initials(me) }}
        </span>
      </ng-template>

      <span class="sidebar-footer__identity">
        <span class="sidebar-footer__name">{{ fullname(me) }}</span>
        <span class="sidebar-footer__role" *ngIf="role(me)">{{ role(me) }}</span>
      </span>
    </div>

    <!-- Placeholder keeps the footer at a stable height while `me` loads. -->
    <ng-template #userSkeleton>
      <div class="sidebar-footer__user sidebar-footer__user--loading">
        <span class="sidebar-footer__avatar sidebar-footer__avatar--placeholder"></span>
        <span class="sidebar-footer__identity">
          <span class="sidebar-footer__name-placeholder"></span>
          <span class="sidebar-footer__role-placeholder"></span>
        </span>
      </div>
    </ng-template>
  </ng-container>

  <button
    type="button"
    class="sidebar-footer__logout"
    data-testid="logout-button"
    [attr.aria-label]="'authentication.logout' | translate"
    [title]="'authentication.logout' | translate"
    (click)="logout.emit()">
    <ui-icon name="LogOut"></ui-icon>
  </button>

</div>
